import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TeacherAssignment } from '../api/AssignmentTeacherApi';
import Assignment from './Assignment';

const BASE = 'PAGES.ASSIGNMENTS.TEACHER.SECTION.TABLE.BODY.ASSIGNMENT_DIVISIONS';

export type EndDateCategory = 'TODAY' | 'THIS_WEEK' | 'LATER' | 'LAST_WEEK' | 'LAST_TWO_WEEKS' | 'IN_LAST_MONTH';

type AssignmentDivisionProps = {
  endDateCategory: EndDateCategory;
  assignments: TeacherAssignment[];
  monthAndYear?: string;
};

function AssignmentDivision({ endDateCategory, assignments, monthAndYear }: AssignmentDivisionProps) {
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();

  const title = t(`${BASE}.END_DATE.${endDateCategory}`, { monthAndYear });
  const emptyMessage = t(`${BASE}.EMPTY_MESSAGE.${endDateCategory}`);

  const isEmpty = assignments.length === 0;
  const hasOne = assignments.length === 1;

  return (
    <>
      <tr>
        <CellWithHierarchy
          highlighted
          hierarchyProps={{
            level: 0,
            onToggleCollapsed: () => setCollapsed(x => !x),
            collapsed,
            collapseButtonLabelText: t(`${BASE}.COLLAPSE_BUTTON.A11Y_LABEL`),
          }}
          colspan={5}
        >
          <Cell.Text
            title={title}
            subTitle={{
              text: hasOne
                ? t(`${BASE}.ONE_ASSIGNMENT`)
                : t(`${BASE}.ASSIGNMENTS_COUNT`, { count: assignments.length }),
              position: 'bottom',
            }}
          />
        </CellWithHierarchy>
        <Cell highlighted className="actions-cell" sticky />
      </tr>
      {!collapsed && isEmpty && (
        <tr>
          <CellWithHierarchy hierarchyProps={{ level: 1, hasCollapsibleParent: true }} colspan={5}>
            <Cell.Message title={emptyMessage} />
          </CellWithHierarchy>
          <Cell className="actions-cell" sticky />
        </tr>
      )}
      {!collapsed &&
        !isEmpty &&
        assignments.map(assignment => (
          <Assignment
            key={`${assignment.materialId}-${assignment.school.name}-${assignment.group || 'all-groups'}-${
              assignment.to
            }`}
            assignment={assignment}
            endDateCategory={endDateCategory}
          />
        ))}
    </>
  );
}

export default AssignmentDivision;
